export const statusResponse = {
    SUCCESS: 200,
    CREATE: 201, 
    DELETE_SUCCESS: 204
}